import { FiltersQuery } from "../../../types/FilterQuery.interface";
import { UseQueryProps } from "../../../hooks/useQuery";
import React, { Suspense, useCallback, useEffect, useState } from "react";
import { BsBellFill } from "react-icons/bs";
import dynamic from "next/dynamic";
import { apiClient } from "../../../utils/apiClient";
import { BiRefresh } from "react-icons/bi";
import { useRouter } from "next/router";
import useStore from "../../../context/useStore";

const MoreFilters = dynamic(() => import("./MoreFilters"), {
  suspense: true,
});

const PriceFilters = dynamic(() => import("./PriceFilters"), {
  suspense: true,
});

const TypeFilters = dynamic(() => import("./TypeFilters"), {
  suspense: true,
});

const StylesFilters = dynamic(() => import("./StylesFilters"), {
  suspense: true,
});

const ListingAlert = dynamic(() => import("./ListingAlert"), {
  suspense: true,
});

interface FiltersProps {
  query: FiltersQuery;
  queries: UseQueryProps;
  isMobile?: boolean;
}

const Filters: React.FC<FiltersProps> = ({
  queries,
  query,
}) => {
  const { push } = queries;
  const [show, setShow] = useState(false);

  const router = useRouter();
  const { auth } = useStore();

  const track = useCallback(async (city: string) => {
    await apiClient.post("/api/v1/track/page", { page: city });
  }, []);

  useEffect(() => {
    if (auth.login) {
      if (auth.role === "user") {
        track(query.city || "");
      }
    }
  }, [auth.login, query.city, auth.role, track]);

  return (
    <>
      <div className="flex gap-4 overflow-x-auto px-5 md:px-2 no-scrollbar">
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <StylesFilters push={push} query={query} />
        </Suspense>
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <TypeFilters push={push} query={query} />
        </Suspense>

        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <PriceFilters push={push} query={query} />
        </Suspense>
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <MoreFilters push={push} query={query} />
        </Suspense>

        <button
          className="flex gap-2 min-w-fit"
          onClick={() => {
            if (router.query.city) {
              router.push("/city/" + router.query.city);
            } else if (router.query.area) {
              router.push("/area/" + router.query.area);
            }
          }}
        >
          <BiRefresh fontSize={22} /> <span>Clear Filter</span>
        </button>

        <button
          onClick={() => setShow((pre) => !pre)}
          className="flex gap-2 justify-center items-center whitespace-nowrap"
        >
          <BsBellFill /> Listing Alert
        </button>
      </div>
      <Suspense fallback={<></>}>
        <ListingAlert visible={show} onClose={() => setShow(false)} />
      </Suspense>
    </>
  );
};

export default Filters;
